export const Headers = {
  set: setHeaders,
};

const defaultOptions = {
  auth: true,
  ignoreType: false,
};

function setHeaders(options) {
  const { ignoreType, auth } = options ? options : defaultOptions;
  const headers = {};
  if (!ignoreType) {
    headers['Content-Type'] = 'application/json';
  }
  if (auth) {
    let user = null;
    if (window.sessionStorage.getItem('chronos-user')) {
      user = JSON.parse(window.sessionStorage.getItem('chronos-user'));
    }
    if (user && user !== null && user.token) {
      const { token } = user;
      if (token && token.length > 0) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    }
  }

  return headers;
}
